import React from 'react';

export interface NmSkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

/** Neumorphic inset placeholder with shimmer — for loading states. */
export function NmSkeleton({
  width = '100%',
  height = 14,
  radius = 8,
  className = '',
  style,
}: NmSkeletonProps) {
  return (
    <div
      className={`nm-skeleton ${className}`.trim()}
      style={{ width, height, borderRadius: radius, ...style }}
      aria-hidden
    >
      <div className="nm-skeleton__shine" />
    </div>
  );
}

export function NmSkeletonRows({
  rows = 5,
  rowHeight = 38,
  gap = 8,
}: {
  rows?: number;
  rowHeight?: number;
  gap?: number;
}) {
  return (
    <div style={{ display: 'grid', gap }} aria-hidden>
      {Array.from({ length: rows }, (_, i) => (
        <NmSkeleton key={i} height={rowHeight} style={{ opacity: Math.max(0.55, 1 - i * 0.07) }} />
      ))}
    </div>
  );
}
